/* ================================================================
   SURULERE PREMIUM JS — Mobile Cart Bar, Back-to-Top
   ================================================================ */
(function () {
  'use strict';

  /* ── 1. MOBILE STICKY ADD-TO-CART BAR ────────────────────────── */
  function initMobileCartBar() {
    if (window.innerWidth > 749) return;

    var productForm = document.querySelector('.product-form');
    var productTitle = document.querySelector('.product__title h1');
    var priceEl = document.querySelector('.product__info-wrapper .price-item--regular, .product__info-wrapper .price-item--sale');
    var submitBtn = document.querySelector('.product-form__submit');

    if (!productForm || !submitBtn) return;

    var bar = document.createElement('div');
    bar.className = 'sf-mobile-cart-bar';
    bar.innerHTML =
      '<div class="sf-mcb-info">' +
        '<div class="sf-mcb-title">' + (productTitle ? productTitle.textContent.trim() : 'Product') + '</div>' +
        '<div class="sf-mcb-price">' + (priceEl ? priceEl.textContent.trim() : '') + '</div>' +
      '</div>' +
      '<button class="sf-mcb-btn" type="button">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:middle;margin-right:4px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>' +
        'Add to Cart' +
      '</button>';

    document.body.appendChild(bar);
    document.body.classList.add('sf-has-mobile-cart');

    bar.querySelector('.sf-mcb-btn').addEventListener('click', function () {
      submitBtn.click();
    });

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('sf-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    obs.observe(submitBtn);
  }

  /* ── 2. PRODUCT GALLERY PAGINATION DOTS ─────────────────────── */
  /* Keeps .product-gallery-dots in sync with the native slider's
     .slider-counter--current text (no need to hook into the
     slider-component's internal scroll logic). Decorative only. */
  function initGalleryDots() {
    var dotContainers = document.querySelectorAll('[data-gallery-dots]');
    if (!dotContainers.length) return;

    dotContainers.forEach(function (dots) {
      var mediaGallery = dots.closest('media-gallery');
      var counter = mediaGallery ? mediaGallery.querySelector('.slider-counter--current') : null;
      if (!counter) return;

      var setActive = function () {
        var index = parseInt(counter.textContent, 10);
        if (!index || isNaN(index)) return;
        var allDots = dots.querySelectorAll('.dot');
        allDots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index - 1);
        });
      };

      setActive();
      new MutationObserver(setActive).observe(counter, { characterData: true, childList: true, subtree: true });
    });
  }

  /* ── 3. BACK-TO-TOP BUTTON ──────────────────────────────────── */
  function initBackToTop() {
    var btn = document.createElement('button');
    btn.className = 'sf-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="18 15 12 9 6 15"/></svg>';
    document.body.appendChild(btn);

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          btn.classList.toggle('sf-visible', window.scrollY > 600);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── INIT ────────────────────────────────────────────────────── */
  function init() {
    initBackToTop();
    initGalleryDots();

    /* Mobile sticky add-to-cart is provided by snippets/sticky-add-to-cart.liquid
       (.sticky-atc), which also keeps the button's variant/price/image in sync.
       initMobileCartBar() is intentionally disabled here so we don't render two
       competing sticky bars on mobile product pages (.sf-mobile-cart-bar vs
       .sticky-atc). The function above is left in place but unused, in case it's
       needed again. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
